export default "__VITE_ASSET__C$QwNNpJ__"